export class OrderRequest {
	date: number;
	detail: DetailOrderRequest[] = [];
	warehouse: number;
	clientId: number | null;
}

export class DetailOrderRequest {
	productId: number;
	quantity: number;
	reserved?: boolean;
	price?: number;

	constructor(productId: number, quantity: number, reseved: boolean = false, price: number = 0) {
		this.productId = productId;
		this.quantity = quantity;
		this.reserved = reseved;
		this.price = price;
	}
}

export class OrderPolishOffRequest {
	date: number;
	isCancelled: boolean;
	orderId: string;
	products: DetailPolishOffRequest[] = [];
}

export class DetailPolishOffRequest {
	detailId: number;
	productId: number;
	quantity: number;

	constructor(detailId: number, productId: number, quantity: number) {
		this.detailId = detailId;
		this.productId = productId;
		this.quantity = quantity;
	}
}

export class DetailsOrderClimbRequest {
	orderId: number;
	userId: number;
	orderDetailId: number[] = [];
}

export class OrderClientRequest {
	creationDate: number;
	detail: DetailOrderRequest[] = [];
	warehouseId: number;
	clientId: number | null;
}